import { FC } from 'react';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@features/ui';

type TYearSelectorProps = {
  value: string;
  onChange: (value: string) => void;
  maxYear?: number;
  minYear?: number;
};

export const YearSelector: FC<TYearSelectorProps> = ({
  value,
  onChange,
  maxYear = new Date().getFullYear(),
  minYear = 2010,
}) => {
  const years = Array.from(
    { length: maxYear - minYear + 1 },
    (_, i) => maxYear - i
  );

  return (
    <div className="flex items-center gap-3">
      <label className="text-sm font-medium">Year</label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Select year" />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {years.map((year) => (
              <SelectItem key={year} value={year.toString()}>
                {year}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};
